// extracted by mini-css-extract-plugin
module.exports = {"main-cnt":"Readme_main-cnt__1I8Vo","main-header":"Readme_main-header__3txsX","readme-textarea":"Readme_readme-textarea__1okVa","readme-value":"Readme_readme-value__Va16j"};